export default __webpack_public_path__ + "static/media/unlocked.5b465e1e.svg";